
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","data-name":"Layer 1","viewBox":"0 0 24 24","width":"512","height":"512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19 0h-6c-2.757 0-5 2.243-5 5v6c0 2.757 2.243 5 5 5h6c2.757 0 5-2.243 5-5V5c0-2.757-2.243-5-5-5zm3 11c0 1.654-1.346 3-3 3h-6c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3h6c1.654 0 3 1.346 3 3v6zm-6 8c0 2.757-2.243 5-5 5H5c-2.757 0-5-2.243-5-5v-6c0-2.757 2.243-5 5-5a1 1 0 110 2c-1.654 0-3 1.346-3 3v6c0 1.654 1.346 3 3 3h6c1.654 0 3-1.346 3-3a1 1 0 112 0z"}})])
          )
        }
      }
    